<template>
    <div class="login-container">
      <div class="login-wrapper">
        <div class="login-content">
        <!-- page content -->
        <div class="col-md-12">
            <div class="col-middle">
            <div class="text-center text-center">
                <h1 class="error-number mb-2">404</h1>
                <h2　class="mb-2">Sorry but we couldn't find this page</h2>
                <p>This page you are looking for does not exist</p>
                <p class="mb-5"><a href="#">Report this?</a></p>
                <div class="mid_center">
                <h3 class="mt-5">Search</h3>
                <form>
                    <div class="col-xs-12 form-group pull-right top_search">
                    <div class="input-group">
                        <input type="text" class="form-control" placeholder="Search for...">
                        <v-btn color="blue" dark>Go!</v-btn>
                            <!--<button class="btn btn-default" type="button">Go!</button>-->
                    </div>
                    </div>
                </form>
                </div>
            </div>
            </div>
        </div>
        <!-- /page content -->
        </div>
        <div class="login-bottom">
          <div class="login-logo">
            <img src="../assets/images/logo02.png" alt="">
          </div>
          <div>
           <small>{{copyright}}</small>
         </div>
       </div>
      </div>
    </div>
</template>

<script>
import utils from '@/utils/utils.js'

export default {
  name: 'Page404',
  data () {
    return {
      copyright: ''
    }
  },
  methods: {
    getDomainConfig () {
      let domainConfig = utils.getDomainConfig()
      this.copyright = domainConfig.copyright
    }
  },
  mounted () {
    this.getDomainConfig()
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// Page404.vue?5ea3c1b8